import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { AdminLayout } from "./components/admin/AdminLayout";
import { BesluitDrafting } from "./components/besluit/BesluitDrafting";
import { ChatInterface } from "./components/chat/ChatInterface";
import { ProfilePage } from "./components/profile/ProfilePage";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";

// Create a client outside of the component to avoid recreating on each render
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Chat is the default landing page */}
            <Route path="/" element={<ChatInterface />} />
            <Route path="/besluit" element={<BesluitDrafting />} />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}

// Admin page with React admin interface
function AdminPage() {
  return (
    <div className="min-h-screen bg-surface-3">
      <AdminLayout />
    </div>
  );
}

export default App;
